<template>
  <div class="users">
    <Breadcrumb :home="home" />
    <div class="filters">
      <Dropdown v-model="approvedSelected" :options="approvedtypes" />
      <span class="p-input-icon-left">
        <i class="pi pi-filter" />
        <InputText type="text" v-model="filterText" placeholder="Filter" />
      </span>
    </div>
    <div class="user_list">
      <div class="user" v-for="u in filteredUsers" :key="u.id">
        <div class="name item">
          <b>{{ u.rank }}</b>
        </div>
        <div class="name item">
          {{ u.firstname }} <b>{{ u.lastname }}</b>
        </div>
        <div class="uic item">
          UIC:
          <b>{{ u.uic }}</b>
        </div>
        <div class="email item">
          {{ u.email }}
        </div>
        <div class="dod item">
          {{ u.dod }}
        </div>
        <div class="approval item">
          Access Approved:
          <b>{{ u.approved }}</b>
        </div>
        <div class="role item">
          Role:
          <b>{{ u.role }}</b>
        </div>
        <div class="selector">
          <router-link tag="div" class="edit p-shadow-8" :to="'/users/' + u.id"
            >Edit</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fb_db, fs, fb_auth } from "../firebase";
import Breadcrumb from "primevue/breadcrumb";
import Dropdown from "primevue/dropdown";

export default {
  name: "Users",
  components: {
    Breadcrumb,
    // Dialog,
    Dropdown,
  },
  data() {
    return {
      home: { label: "Users List", to: "/users" },

      users: [],
      confirmRemoveDialog: false,
      filterText: "",
      approvedSelected: "Not Approved",
      approvedtypes: ["All", "Approved", "Not Approved"],
      removethisuser: null,

      options: [
        {
          name: "Approved",
          code: true,
        },
        {
          name: "Not Approved",
          code: false,
        },
      ],
      roles: ["Operator", "Mechanic", "Maint. Manager", "Clers", "Org. Leader"],
    };
  },
  async mounted() {
    await this.getUsers();
  },
  methods: {
    async getUsers() {
            this.loading = true;
      let userRef = await fb_db.collection("users").doc(fb_auth.currentUser.uid).get()
      let user = userRef.data()
      this.loading = true;
      await fb_db
        .collection("users").where("puic", "==", user.puic) 
        .get()
        .then((docs) => {
          let payload = [];
          docs.forEach((doc) => {
            let item = doc.data();
            item.id = doc.id;
            this.users.push(item);
          });
          this.loading = false;
        })
        .catch((error) => {
          console.error("error getting users: ", error);
        });
    },
    confirmRemove(user) {
      console.log("confirm remove");
      this.confirmRemoveDialog = true;
      this.removethisuser = user;
    },
    deleteUser() {
      console.log("Remove user: ", this.removethisuser);
      fb_db
        .collection("users")
        .doc(this.removethisuser.id)
        .delete()
        .then(() => {
          this.removethisuser = null;
          this.getUser();
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
  computed: {
    filteredUsers() {
      return this.users.filter((u) => {
        if (this.approvedSelected == "All") {
          return (
            u.firstname
              .concat(" " + u.lastname)
              .toLowerCase()
              .indexOf(this.filterText.toLowerCase()) > -1
          );
        } else if (this.approvedSelected == "Approved") {
          return (
            u.approved == true &&
            u.firstname
              .concat(" " + u.lastname)
              .toLowerCase()
              .indexOf(this.filterText.toLowerCase()) > -1
          );
        } else {
          return (
            u.approved == false &&
            u.firstname
              .concat(" " + u.lastname)
              .toLowerCase()
              .indexOf(this.filterText.toLowerCase()) > -1
          );
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/theme.scss";

.users {
  .user_list {
    position: absolute;
    width: 100vw;
    height: calc(100% - 200px);
    overflow-y: scroll;

    .user {
      width: 300px;
      background: #efefef;
      border-radius: 10px;
      margin: 10px;
      float: left;

      .selector {
        padding: 10px;
        display: flex;

        div {
          margin: 0px 5px;
          padding: 5px 15px;
          border-radius: 5px;
          // color: $white;
        }

        .edit {
          background: $accent;
          // color: $text;
          cursor: pointer;
        }

        .delete {
          background: $primary;
          // color: $white;
          cursor: pointer;
        }

        .item {
          padding: 10px;
          text-align: left;
        }

        .name {
        }

        .email {
        }

        .dod {
        }

        .approval {
        }

        .role {
        }
      }
    }
  }
}
</style>